export enum TransitionQueries {
  TransitionTable = 'transitionTable',
  SearchTransitionElementNew = 'searchTransitionElementNew',
  SearchTransitionElementOld = 'searchTransitionElementOld',
}
